<div class="flex items-center">
  <mat-icon [style.color]="statusView.color">{{ statusView.icon }}</mat-icon>
  <span class="pl-8 text-primary mt-4" *ngIf="statusView.label">{{
    'admin.access.statuses.' + statusView.label | translate
  }}</span>
</div>
